import {React, _n} from 'pexui';
import {inArray} from '../../utilities/utils';
import {RadioButon} from './uicomps';

const getChoiceTitle = (choiceNodes) => {
    var value = "";
    choiceNodes.forEach((node2,index)=>{
        if(index == 0){
            value = getNodeTitle(node2);
        }else{
            value = value + " & " + getNodeTitle(node2);
        }
    });
    return value;
}

const getNodeTitle = (node) => {
    var value = '';
    if(node.choices){
        node.choices.forEach((choice, index) => {
            if(index == 0){
                value = getChoiceTitle(choice);
            }else{
                value = value + ' ' + _n('widget.doc_options.or') + ' ' + getChoiceTitle(choice);
            }
        });
    }else if(node.widgetOption){
        value = _n(node.widgetOption.content_id + '.title', {business_name:node.account.organization_name||''});
    }
    return value;
}

export const ChoiceSection = ({page, flow, node, className, style}) => {
    const widget = page.props.widget;
    let contents = [];

    node.choices.forEach((choice,index)=>{
        if(index > 0){
            contents.push(<br/>);
        }
        contents.push(<RadioButon 
            label={getChoiceTitle(choice)}
            name="doc_choice"
            onClick={()=> {
                flow.setCurrentNode(node);                
                flow.down(index);
                page.setState({level: page.state.level + 1});
            }}/>);
    });

    return <div className={className} style={style}>
              <div className="text-align-left">{_n('DocUpload.choice.message')}</div>
              <br/>
              <div className="text-align-left">
                {contents}
              </div>
           </div>;
}




// WEBPACK FOOTER //
// ./application/src/views/comps/choice.jsx